module.exports = __webpack_public_path__ + "static/media/roshikagyawali.21d461ae.jpg";